import React from 'react'

const SvgIconUnplugged = (props) => (
  <svg viewBox="0 0 23 23" {...props}>
    <path
      d="M22.075 7.064A11.471 11.471 0 0 0 11.478 0a11.44 11.44 0 0 0-8.082 3.337.351.351 0 0 0-.035.024.351.351 0 0 0-.024.035c-4.458 4.483-4.448 11.729.023 16.2 4.47 4.47 11.717 4.48 16.2.022a.344.344 0 0 0 .035-.023.351.351 0 0 0 .023-.035 11.471 11.471 0 0 0 2.457-12.496zM7.199 21.3a10.705 10.705 0 0 1-6.434-9.823 10.67 10.67 0 0 1 2.877-7.295l2.862 2.862v11.32c0 .633.514 1.146 1.148 1.147h6.886c.634 0 1.148-.514 1.148-1.148v-2.137l3.086 3.086A10.705 10.705 0 0 1 7.2 21.301zm7.722-14.797v7.876L7.269 6.728v-.224h7.652zM7.269 5.74V4.591c0-.211.172-.382.383-.382h6.886c.212 0 .383.171.383.382V5.74H7.269zm7.652 9.723v.99H7.269V7.81l7.652 7.652zm0 1.755v1.147a.383.383 0 0 1-.383.383H7.652a.383.383 0 0 1-.383-.383v-1.147h7.652zm4.392 1.555l-3.627-3.627V4.591a1.15 1.15 0 0 0-1.148-1.148H7.652a1.15 1.15 0 0 0-1.148 1.148v1.372l-2.32-2.32a10.705 10.705 0 0 1 15.13 15.13z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconUnplugged
